export const environment = {
  production: true,
  baseUrl: '',
  authUrl: '/auth',
  apiCrudUrl: '/api',
  apiBaseUrl: '/api',
  apiBIUrl: '/api/bi',
  jsUrl: '/js',
  iconUrl: '',
  cubeJSUrl: '/cubejs',
  internalUrl: '/internal',
  apiAutostartUrl: '/autostart',
  api3DUrl: '/api/3d'
  //cubeJSUrl: 'http://192.168.1.12:4001/cubejs-api/v1',
  // apiCrudUrl: `${window.location.protocol}//${window.location.hostname}:18082/api`,
  // apiBaseUrl: `${window.location.protocol}//${window.location.hostname}:18083/api`,
};
(window as any).environment=environment;
